// plugins/digestString.js
import _ from 'lodash';

let digestString = {
  install(app) {
    app.config.globalProperties.$digestString = function(ClientInstance, ClientInstances) {
      const children = _.isEmpty(ClientInstance.iBranch) ? null : ClientInstances.filter(cI => _.isEmpty(cI.iBranch) ? null : cI.iBranch.Parent.ID === ClientInstance.iBranch.Child.ID);
      let myString = '';
      if (!_.isEmpty(children) && ClientInstance.iBranch) {
        const digestSort = _.isEmpty(children) ? null : _.orderBy(children.filter(c => c.ClientBranch.Branch.digest), 'ClientBranch.Branch.digest', 'asc');
        let result = _.isEmpty(digestSort) ? null : digestSort.map(d => d.iBranch.Child.value);
        if (result) {
          result.forEach(r => {
            myString === '' ? myString += r : myString += ', ' + r;
          });
        }
      }
      return myString;
    }
  }
};

export default digestString;